import { Container, makeStyles } from '@material-ui/core';
import React from 'react';
import ContactForm from '../components/ContactForm/ContactForm';
import MySocialMedias from '../components/MySocialMedias';
import AnimatedBackground from '../ui/AnimatedBackground';
import usePageStyle from './usePageStyle';

const useLocalStyle = makeStyles(theme => ({
  container: {
    height: '50vh',
    paddingTop: '2em',
    marginBottom: '4em',
    [theme.breakpoints.down('md')]: {
      height: '80vh',
      marginBottom: '10em',
    },
    [theme.breakpoints.down('sm')]: {
      height: '40vh',
    },
  },
}));

const Contact = () => {
  const classes = usePageStyle();
  const localClasses = useLocalStyle();

  return (
    <>
      <AnimatedBackground />
      <main className={classes.page}>
        <Container className={localClasses.container} maxWidth="sm">
          <ContactForm />
        </Container>
        <MySocialMedias />
      </main>
    </>
  );
};

export default Contact;
